import React from 'react';

function SquareWithPiece({
    isBlack,
    position,
    setClickedSquare,
    amICorrect,
    boardSize,
    highlight = false,
    piece,
    isActiveSide = false,
    locked = false,
    isDraggingFrom = false,
    onPieceDragStart = null,
}) {
    const handleClick = () => {
        if (locked) return;
        setClickedSquare(position);
        amICorrect(position);
    };

    const handlePointerDown = (e) => {
        if (locked || !piece || !onPieceDragStart) return;
        // Only initiate drag on primary button (left click)
        if (e.button !== undefined && e.button !== 0) return;
        onPieceDragStart(position, piece, e);
    };

    return (
        <div
            style={styles.square(isBlack, boardSize, highlight)}
            onClick={handleClick}
        >
            {piece && (
                <img
                    src={piece}
                    alt=""
                    draggable={false}
                    onPointerDown={handlePointerDown}
                    style={{
                        width: '88%',
                        height: '88%',
                        cursor: locked ? 'default' : 'grab',
                        filter: isActiveSide
                            ? 'drop-shadow(0 0 5px rgba(255, 210, 0, 0.95))'
                            : 'none',
                        opacity: isDraggingFrom ? 0.25 : 1,
                        userSelect: 'none',
                        transition: 'opacity 0.05s',
                    }}
                />
            )}
        </div>
    );
}

const styles = {
    square: (isBlack, boardSize, highlight) => {
        const size = `${100 / boardSize}%`;
        return {
            width: size,
            height: size,
            backgroundColor: highlight ? 'rgba(20, 255, 20, 0.5)' : isBlack ? '#E87900' : 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        };
    },
};

export default SquareWithPiece;
